import styled from '@emotion/styled';

export const ParentLocalesWrapper = styled.div`
    display: block;
    width: 100%;
`;

export const FolderParentName = styled.span`
    font-size: small;
    font-weight: bold;
`;

export const LocalesOnFolder = styled.span`
    font-size: small;
`;